import React, { useState } from "react";
import { MockupFrame } from "./MockupFrame";

const MESSAGES = [
	{
		author: "Steven Lux.red",
		time: "1:40 PM",
		comp: { label: "(Comp 4) 17395 De Witt Ave", color: "#f97316" },
		media: 0,
		text: "Roofline 2,213",
	},
	{
		author: "Steven Lux.red",
		time: "9:28 PM",
		text: "hello",
	},
	{
		author: "Steven Lux.red",
		time: "9:42 PM",
		comp: { label: "(Comp 4) 17395 De Witt Ave", color: "#f97316" },
		media: 36,
		text: "yoooo!!",
		edited: true,
	},
	{
		author: "Steven Lux.red",
		time: "9:46 PM",
		badge: { label: "Light Reno", color: "#22c55e" },
		text: "Test",
	},
	{
		author: "Steven Lux.red",
		time: "9:47 PM",
		comp: { label: "(Comp 5) 17065 Piedmont Ct", color: "#22c55e" },
		media: 1,
		text: "hello!!",
	},
	{
		author: "Steven Lux.red",
		time: "9:48 PM",
		badge: { label: "Light Reno", color: "#22c55e" },
		text: "Yello!",
	},
];

const MESSAGES_2 = [
	{
		author: "Steven Lux.red",
		time: "12:47 PM",
		text: "What's up bro!!",
		reply: { author: "Steven Lux.red", label: "[Calculator: Light Reno] Test" },
	},
	{
		author: "Steven Lux.red",
		time: "12:48 PM",
		text: "",
		mention: { name: "@Steven Member", text: " Hello!" },
	},
	{
		author: "Steven Lux.red",
		time: "12:48 PM",
		text: "hello!",
	},
	{
		author: "Steven Lux.red",
		time: "8:57 PM",
		badge: { label: "Full Reno", color: "#ef4444" },
		text: "Just a test. not actual numbers.",
	},
	{
		author: "Steven Lux.red",
		time: "9:17 PM",
		comp: { label: "(Comp 4) 17395 De Witt Ave", color: "#f97316" },
		media: 12,
		text: "hello!!",
	},
	{
		author: "Steven Lux.red",
		time: "11:34 PM",
		text: "",
		styledText: { content: "hello", color: "#22c55e" },
	},
];

export function MockupTeamChat() {
	const [hoveredMsg, setHoveredMsg] = useState<number | null>(null);
	const [composerFocused, setComposerFocused] = useState(false);

	const renderMessage = (msg: (typeof MESSAGES)[number] | (typeof MESSAGES_2)[number], i: number, offset: number) => {
		const globalIndex = offset + i;
		const m = msg as any;
		return (
			<div
				key={globalIndex}
				onMouseEnter={() => setHoveredMsg(globalIndex)}
				onMouseLeave={() => setHoveredMsg(null)}
				className={`flex items-start gap-2 rounded-md px-2 py-1 transition-colors ${hoveredMsg === globalIndex ? "bg-white/[0.02]" : ""}`}
			>
				<div className="flex-1 min-w-0">
					{/* Reply bar */}
					{m.reply && (
						<div className="flex items-center gap-1.5 mb-0.5 text-[9px]">
							<svg className="h-3 w-3 text-zinc-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
								<path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
							</svg>
							<span className="text-zinc-500 font-medium">{m.reply.author}</span>
							<span className="text-zinc-600 truncate">{m.reply.label}</span>
						</div>
					)}
					<div className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5">
						<span className="text-[10px] font-semibold text-zinc-300">{m.author}</span>
						<span className="text-[9px] text-zinc-600">{m.time}</span>
						{m.comp && (
							<span className="text-[9px] font-medium" style={{ color: m.comp.color }}>{m.comp.label}</span>
						)}
						{m.media !== undefined && m.media > 0 && (
							<span className="text-[8px] text-zinc-600">&#128247; {m.media}</span>
						)}
						{m.edited && (
							<span className="text-[8px] text-zinc-600 italic">(edited)</span>
						)}
						{m.badge && (
							<span
								className="text-[8px] font-bold px-1.5 py-0.5 rounded"
								style={{ backgroundColor: `${m.badge.color}20`, color: m.badge.color }}
							>
								{m.badge.label}
							</span>
						)}
					</div>
					<p className="text-[10px] text-zinc-300 mt-0.5">
						{m.mention && (
							<>
								<span className="text-emerald-400 font-medium">{m.mention.name}</span>
								{m.mention.text}
							</>
						)}
						{m.styledText && (
							<span className="font-bold" style={{ color: m.styledText.color }}>{m.styledText.content}</span>
						)}
						{m.text}
					</p>
				</div>
				{/* Hover actions */}
				{hoveredMsg === globalIndex && (
					<div className="flex items-center gap-0.5 shrink-0 animate-[fadeSlideIn_0.1s_ease]">
						{[
							"M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
							"M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z",
							"M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125",
						].map((d, j) => (
							<button key={j} className="h-5 w-5 rounded flex items-center justify-center text-zinc-600 hover:text-zinc-400 hover:bg-white/5 transition-colors">
								<svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
									<path strokeLinecap="round" strokeLinejoin="round" d={d} />
								</svg>
							</button>
						))}
					</div>
				)}
			</div>
		);
	};

	return (
		<MockupFrame url="comps.red/messaging">
			<div className="flex flex-col h-[400px]">
				{/* Channel Header */}
				<div className="border-b border-white/5 px-4 py-2 flex items-center justify-between shrink-0">
					<div>
						<span className="text-sm font-semibold text-white">17395 De Witt Ave, Morgan Hill, CA</span>
						<div className="flex items-center gap-2 text-[10px] text-zinc-500 mt-0.5">
							<span>6 properties</span>
							<span>&middot;</span>
							<span>37 media</span>
							<span>&middot;</span>
							<span>Comp Decks</span>
						</div>
					</div>
					<div className="flex items-center gap-1">
						{[
							"M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5-7.5L16.5 3m0 0L12 7.5M16.5 3V16.5",
							"M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
							"M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0",
						].map((d, i) => (
							<div key={i} className="h-6 w-6 rounded flex items-center justify-center text-zinc-600 hover:text-zinc-400 cursor-pointer transition-colors">
								<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
									<path strokeLinecap="round" strokeLinejoin="round" d={d} />
								</svg>
							</div>
						))}
					</div>
				</div>

				{/* Messages */}
				<div className="flex-1 overflow-y-auto px-2 py-2 space-y-0.5">
					{/* Date separator 1 */}
					<div className="flex items-center gap-3 py-1.5">
						<div className="flex-1 h-px bg-white/5" />
						<span className="text-[9px] text-zinc-600">Tuesday, March 3, 2026</span>
						<div className="flex-1 h-px bg-white/5" />
					</div>

					{MESSAGES.map((msg, i) => renderMessage(msg, i, 0))}

					{/* Date separator 2 */}
					<div className="flex items-center gap-3 py-1.5">
						<div className="flex-1 h-px bg-white/5" />
						<span className="text-[9px] text-zinc-600">Wednesday, March 4, 2026</span>
						<div className="flex-1 h-px bg-white/5" />
					</div>

					{MESSAGES_2.map((msg, i) => renderMessage(msg, i, MESSAGES.length))}
				</div>

				{/* Composer */}
				<div className="border-t border-white/5 px-3 py-2 shrink-0">
					<div
						className={`rounded-lg border bg-zinc-800/40 transition-colors ${
							composerFocused ? "border-[#db241e]/30 ring-1 ring-[#db241e]/10" : "border-white/5"
						}`}
						onClick={() => setComposerFocused(true)}
						onMouseLeave={() => setComposerFocused(false)}
					>
						{/* Toolbar */}
						<div className="flex items-center gap-0.5 px-2 py-1.5 border-b border-white/5">
							{/* Sparkles */}
							<div className="rounded p-1 text-purple-400/60 hover:text-purple-400 hover:bg-purple-500/10 cursor-pointer transition-colors">
								<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
									<path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
								</svg>
							</div>
							{/* Formatting */}
							{["B", "I", "U", "S"].map((icon) => (
								<div key={icon} className="rounded p-1 text-zinc-600 hover:text-zinc-400 hover:bg-white/5 cursor-pointer transition-colors text-[10px] font-bold w-6 h-6 flex items-center justify-center">
									{icon}
								</div>
							))}
							<div className="mx-1 h-3.5 w-px bg-zinc-700/60" />
							{/* List, Link, Emoji, Attach, Smiley */}
							{[
								"M8.25 6.75h12M8.25 12h12M8.25 17.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 17.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z",
								"M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m9.86-2.556a4.5 4.5 0 00-6.364-6.364L4.5 8.25",
								"M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
								"M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13",
								"M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z",
							].map((d, i) => (
								<div key={i} className="rounded p-1 text-zinc-600 hover:text-zinc-400 hover:bg-white/5 cursor-pointer transition-colors">
									<svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
										<path strokeLinecap="round" strokeLinejoin="round" d={d} />
									</svg>
								</div>
							))}
						</div>
						{/* Input */}
						<div className="px-3 py-2 flex items-center justify-between">
							<span className={`text-[10px] transition-colors ${composerFocused ? "text-zinc-400" : "text-zinc-600"}`}>
								Message #17395 De Witt Ave, Morgan Hill...
							</span>
							<div className={`rounded-md p-1.5 transition-colors cursor-pointer ${composerFocused ? "bg-[#db241e] hover:bg-[#c41f1a]" : "bg-[#db241e]/50"}`}>
								<svg className="h-3.5 w-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
									<path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MockupFrame>
	);
}
